//@ts-nocheck
import React, { Fragment, Component } from "react";
import classnames from "classnames";
import styles from "./SlideShow.module.scss";

const requestInterval = (fn, delay) => {
  const requestAnimFrame = (() =>
    window.requestAnimationFrame ||
    ((callback) => {
      window.setTimeout(callback, 1000 / 60);
    }))();

  let start = new Date().getTime();
  let paused = false;
  const reset = () => {
    start = new Date().getTime();
  };
  const pause = () => {
    paused = true;
  };
  const handle = {
    reset,
    pause,
  };
  const loop = () => {
    handle.value = requestAnimFrame(loop);
    const current = new Date().getTime();
    const delta = current - start;
    if (delta >= delay && !paused) {
      fn.call();
      start = new Date().getTime();
    }
  };
  handle.value = requestAnimFrame(loop);
  return handle;
};

const Bullet = ({ isActive, onClick, activeClass, className }) => (
  <button
    onClick={onClick}
    className={classnames(className, { [activeClass]: isActive })}
  />
);
class SlideShow extends Component {
  interval = null;
  state = {
    hover: false,
    active: 0,
  };

  componentDidMount() {
    this.animate();
  }

  componentWillUnmount() {
    this.unAnimate();
  }

  handleMouseEnter = () => {
    // this.setState(() => ({ hover: true }));
    // this.unAnimate();
  };

  handleMouseLeave = () => {
    // this.setState((state) => {
    //   if (state.hover) {
    //     this.animate();
    //   }
    //   return { hover: false };
    // });
  };

  next = () => {
    this.setState((state) => ({
      active:
        this.props.images.length - 1 > state.active ? state.active + 1 : 0,
    }));
    this.interval.reset();
  };

  back = () => {
    this.setState((state) => ({
      active:
        state.active !== 0 ? state.active - 1 : this.props.images.length - 1,
    }));
    this.interval.reset();
  };

  goToSlide = (slide) => {
    this.setState(() => ({
      active: slide,
    }));
    this.interval.reset();
  };

  animate = () => {
    this.interval = requestInterval(() => {
      this.setState((state) => ({
        active:
          this.props.images.length - 1 > state.active ? state.active + 1 : 0,
      }));
    }, 4000);
  };

  unAnimate = () => {
    // clearTimeout(this.timeoutCase);
  };

  render() {
    const { active } = this.state;
    const {
      noControls,
      images,
      overlayClass,
      className,
      slideClass,
      bulletClass,
      activeBulletClass,
      bulletsContainerClass,
      navClass,
      nextClass,
      backClass,
    } = this.props;
    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        className={classnames(
          styles.slider,
          className
          // ? "hero-slider--hover" : ""
        )}
      >
        {overlayClass && (
          <div className={classnames(styles.overlay, overlayClass)} />
        )}
        {images &&
          images.length &&
          images.map((image, index) => (
            <Fragment key={index}>
              {/* Preload the first image */}
              {index === 0 && (
                <link
                  rel="preload"
                  // eslint-disable-next-line react/no-unknown-property
                  fetchPriority="high"
                  href={image?.src}
                  as="image"
                />
              )}
              <div
                className={classnames(slideClass, styles.slide, {
                  [styles.slideActive]: index === active,
                })}
              >
                <img
                  src={image?.src}
                  // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                  alt={image?.alt || `Slide Image ${index + 1}`}
                  // eslint-disable-next-line react/no-unknown-property
                  fetchPriority={index === 0 ? "high" : "auto"}
                  loading={index === 0 ? "eager" : undefined}
                />
              </div>
            </Fragment>
          ))}
        {/* controls */}
        {!noControls && images && images.length > 1 && (
          <Fragment>
            <div
              className={classnames(
                styles.bulletsContainer,
                bulletsContainerClass
              )}
            >
              {images &&
                images.length &&
                images.map((_, i) => (
                  <Bullet
                    isActive={active === i}
                    className={classnames(styles.bulletItem, bulletClass)}
                    activeClass={classnames(
                      styles.bulletItemActive,
                      activeBulletClass
                    )}
                    onClick={() => this.goToSlide(i)}
                    key={i}
                  />
                ))}
            </div>
            <span
              className={classnames(styles.navBack, navClass, backClass)}
              onClick={this.back}
            />
            <span
              className={classnames(styles.navNext, navClass, nextClass)}
              onClick={this.next}
            />
          </Fragment>
        )}
      </div>
    );
  }
}

export default SlideShow;
